
import { defineComponent, PropType, readonly, computed, ref, Ref, toRefs, reactive } from "vue";
export default defineComponent({
  props: {
    /**
     * @param {Array} layout 表单布局
     */
    layout: {
      type: Array as PropType<any[]>,
      default: (): any => [],
      required: true,
    },

    /**
     * @param {Object} 当前表单的值
     */
    modelValue: {
      type: Object as PropType<any>,
      default: (): any => {
        return {};
      },
    },

    /**
     * @param {Object} 表单依赖的 数据源
     */
    source: {
      type: Object as PropType<any>,
      default: (): any => {
        return {};
      },
    },
  },
  setup(props, ctx) {
    const propsData: any = reactive(props);
    const modleData = propsData.modelValue;

    /**
     * @param elementsMap 组件信息配置
     */
    const elementsMap: any = {
      "el-input": {
        span: 6,
        placeholder: "请输入",
      },
      "el-select": {
        span: 6,
        placeholder: "请选择",
      },
      "el-cascader": {
        span: 6,
        placeholder: "请选择",
      },
      "el-date-picker": {
        span: 6,
        placeholder: "请选择日期",
      },
      "el-double-date-picker": {
        span: 6,
        placeholder: "请选择日期",
      },
      // "el-time-picker": {
      //    span: 6,
      //    placeholder: "请选择时间",
      // },
      // "el-time-select": {
      //    span: 6,
      //    placeholder: "请选择时间",
      // },
    };

    const form: Ref<null> = ref(null);

    /**
     * 重置表单
     */
    const reset = () => {
      (form.value as any).resetFields();
      ctx.emit("resetForm");
    };

    /**
     * 搜索表单
     */
    const search = () => {
      ctx.emit("searchForm");
    };

    /**
     * @method createLayout 生成表单布局
     */
    const createLayout = computed((): any => {
      // 布局最大24
      const MAX_GRID = 24;
      let count = 0;
      let index = 0;
      const multArr: any = [];

      // 1、过滤掉不在 组件信息配置中的列表
      // 2、填充span 数据
      // 3、生成id优化diff
      const diffLayout: any[] = propsData.layout.filter((el: any, index: number) => {
        if (
          el.type in elementsMap &&
          el.field != null &&
          el.field != undefined
        ) {
          el.bind = el.bind || {};
          el.span = el.span || elementsMap[el.type].span;
          el.placeholder = el.placeholder || elementsMap[el.type].placeholder;
          el.id = Number(
            Math.random().toString().substr(3, 8) + Date.now()
          ).toString(8);

          switch (el.type) {
            case "el-select": {
              el.bind.key = el.bind.key || "key";
              el.bind.label = el.bind.label || "label";
              el.bind.value = el.bind.value || "value";
            }
          }
          return true;
        } else {
          console.warn(
            `props---> layout[${index}] 缺省 field 字段,或者字段值为空`
          );
        }
      });

      // 转换成二维数组
      for (let element of diffLayout) {
        if (count == 0 || count + element.span > MAX_GRID) {
          multArr.push([element]);
        } else {
          multArr[index].push(element);
        }
        count += element.span;
        count > MAX_GRID ? ((count = 0), index++) : false;
      }

      // 计算功能按钮放置的位置
      const sum = multArr[multArr.length - 1]
        .map((el: any) => el.span)
        .reduce((sum: number, nex: number) => sum + nex);

      if (sum > 18) {
        multArr.push([
          {
            type: "form-func",
            span: 24,
            paddingTop: false,
          },
        ]);
      } else {
        multArr[multArr.length - 1].push({
          type: "form-func",
          span: 24 - sum,
          paddingTop: true,
        });
      }
      return multArr;
    });

    return {
      createLayout,
      reset,
      search,
      form,
      modleData,
    };
  },
});
